// Authorization header builder for authenticated fetch calls.
// 2026-05-29 EXTRACTED from src/App.jsx (C1 Phase 2e shared-helpers).
// Imports getSessionToken from src/utils/session.js (already extracted 2026-05-26)
// — NOT from App.jsx, so no import cycle. Re-exported from App.jsx for backward
// compat (13 external importers still import authHeaders from './App.jsx').
import { getSessionToken } from '../utils/session.js';

export function authHeaders() {
  const t = getSessionToken();
  const h = {
    'Content-Type': 'application/json',
    'X-Client-Time': String(Date.now()),
  };
  if (t) h['Authorization'] = `Bearer ${t}`;
  return h;
}
